import React from 'react'

export function CheckedIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      fill="none"
      viewBox="0 0 32 32"
    >
      <circle cx="16" cy="16" r="16" fill="#2AAD87" />
      <path
        fill="#fff"
        d="M13.015 19.636l-3.91-3.91-1.328 1.327 5.238 5.237 11.254-11.253-1.327-1.327-9.927 9.926z"
      />
    </svg>
  )
}
